/**
 * id
 * inputName
 * label
 * inputType
 * placeholder
 * errorMsg
 * className
 * width
 * mask
 * value
 * disabled
 * _function
 */
import React, { useState } from 'react';
import ReactInputMask from 'react-input-mask';

const InputGroup = props => {
    const [isFocused, setIsFocused] = useState(false);
    const {
        id,
        label,
        inputType,
        errorMsg,
        placeholder,
        className,
        width,
        disabled,
        mask,
        inputName,
        _function,
        _max,
        value,
        isTextArea
    } = props

    const _input = () => {
        return (
            <ReactInputMask
                mask={mask}
                type={inputType}
                id={id}
                name={inputName}
                disabled={disabled}
                placeholder={placeholder}
                value={value}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(e) => _function(e.target.value)}
                max={_max}
                className={`${(inputType === 'datetime-local' && className.indexOf('hide-placeholder') >= 0 && !value.length) ? '__hide-placeholder' : ''}`}
            />
        )
    }

    const _textArea = () => {
        return (
            <textarea
                type={inputType}
                id={id}
                disabled={disabled}
                name={inputName}
                placeholder={placeholder}
                value={value}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(e) => _function(e.target.value)}
                 />
        )
    }

    return (
        <div className={`_form-group ${className} ${errorMsg && '_form-group-invalid'} ${disabled && '_form-group-disabled'}`} style={{
            ...(width ? { width } : {})
        }}>
            <label htmlFor={id} className={isFocused ? 'active' : ''}>
                {label}
            </label>
            {isTextArea ? _textArea() : _input()}
            {errorMsg && <span className='_form-group-error-msg '>{errorMsg}</span>}
        </div>
    );
};
export default InputGroup;
